import * as luxon from "luxon";

export default defineNuxtPlugin(() => {
  return {
    provide: {
      luxon,
    },
  };
});
